import SvgIcon, { type SvgIconProps } from 'LuxKit/SvgIcon'

function LineRowStackIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fillRule="evenodd" clipRule="evenodd" d="M20 13C21.1046 13 22 13.8954 22 15V19C22 20.1045 21.1046 21 20 21H4C2.89543 21 2 20.1045 2 19V15C2 13.8954 2.89543 13 4 13H20ZM4 19H20V15H4V19Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M20 3C21.1046 3 22 3.8954 22 5V9C22 10.1046 21.1046 11 20 11H4C2.89543 11 2 10.1046 2 9V5C2 3.8954 2.89543 3 4 3H20ZM4 9H20V5H4V9Z" fill="currentColor" />
  </SvgIcon>
}

export default LineRowStackIcon
